export const SET_VEHICLES = 'SET_VEHICLES'
export const SET_VEHICLE = 'SET_VEHICLE'
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE'
export const INIT_VEHICLE = 'INIT_VEHICLE'



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/types.js